export const NOTIFICATION_DURATION_TIME = 7200;
